import React, { useState } from 'react';
import PopUpForm from "../../../../../../components/Molecules/PopUp/PopUpForm";
import FormEditCollaborator from "../Forms/FormEditCollaborator";

const TableListing = ({ collaborators }) => {
  const [showPopUp, setShowPopUp] = useState(false);
  const [collaboratorID, setCollaboratorID] = useState(0);

  const DisplayEditModalCollaborator = (id) => {
    setCollaboratorID(id)
    setShowPopUp(!showPopUp)
  }

  return (
    <div className='collaborators-tableListing'>

      <table className='collaborators-tableListing-container customTable table-alternateBgColor'>
        <thead>
          <tr>

            <th className='customTable-cellAlignLeft customTable-cellMaxWidth text-tertiary'>Identifiant</th>
            <th className='customTable-cellAlignLeft customTable-cellMaxWidth text-tertiary customTable-cellBg'>Nom</th>
            <th className='customTable-cellAlignLeft customTable-cellMaxWidth text-tertiary'>Prénom</th>
            <th className='customTable-cellMaxWidth text-tertiary customTable-cellBg'>Niveau</th>
            <th className='customTable-cellMaxWidth text-tertiary'>Taux horaire</th>
            <th className='customTable-cellMaxWidth text-tertiary customTable-cellBg'>Base horaire</th>
            <th className='customTable-cellMaxWidth text-tertiary'>Forfait</th>
            <th className='customTable-cellMaxWidth text-tertiary customTable-cellBg'>Obj Prev. An.</th>
            <th className='customTable-cellMaxWidth text-tertiary'>Présence</th>
            <th className='customTable-cellMaxWidth text-tertiary customTable-cellBg'>Obj Prev. Mens.</th>
            <th className='customTable-cellMaxWidth text-tertiary'>Actions</th>
          </tr>
        </thead>

        <tbody>
          {
            collaborators.map((collaborator) => (
              <tr key={collaborator.id}>

                <td className='customTable-cellAlignLeft text-tertiary'>{collaborator.reference}</td>
                <td className='text-tertiary customTable-cellAlignLeft customTable-cellBg'>{collaborator.lastname}</td>
                <td className='customTable-cellAlignLeft text-tertiary'>{collaborator.firstname}</td>
                <td className='text-tertiary customTable-cellBg'>{collaborator.wl ? collaborator.wl : "N/A"}</td>
                <td className='text-tertiary'>{collaborator.rateH ? collaborator.rateH : "N/A"}</td>
                <td className='text-tertiary customTable-cellBg'>{collaborator.baseH ? collaborator.baseH : "N/A"}</td>
                <td className='text-tertiary'>{collaborator.package ? collaborator.package : "N/A"}</td>
                <td className='text-tertiary customTable-cellBg'>{collaborator.objective ? (collaborator.objective * 12).toFixed(2) : "N/A"}</td>
                <td className='text-tertiary'>{collaborator.presence ? collaborator.presence : "N/A"}</td>
                <td className='text-tertiary customTable-cellBg'>{collaborator.objective ? (collaborator.objective).toFixed(2) : "N/A"}</td>
                <td className='text-tertiary color-blue-jeans'>
                  <img alt={"pencil edit collaborator"} onClick={() => DisplayEditModalCollaborator(collaborator.id)} src={"/images/pictos/pencil-blue.svg"} />
                </td>

              </tr>
            ))
          }
        </tbody>

      </table>
      <PopUpForm large={true} title={"Modifier le collaborateur"} form={<FormEditCollaborator setShowPopUp={setShowPopUp} id={collaboratorID} />}
        onClick={DisplayEditModalCollaborator} show={showPopUp} />
    </div>
  );
};

export default TableListing;
